<template>
  <div>
    <Dialog
      header="Peças"
      :visible.sync="localShow"
      :modal="true"
      :closable="true"
      :style="{ width: $isMobile() ? '100vw' : '40vw' }"
      v-bind:class="[{ 'p-dialog-maximized': $isMobile() }]"
    >
      <div class="p-fluid">
        <DataTable
            :value="list"
            class="p-datatable-sm"
            :rowClass="rowClass"
            showGridlines
            responsiveLayout="scroll"
            :loading="loading"
        >
            <template #empty>
                <div class="p-text-center p-p-3">
                    Nenhuma tarefa encontrada para esta data.
                </div>
            </template>

            <Column field="pat_number" header="PAT" :style="{ width: '80px' }">
                <template #body="slotProps">
                    <span class="clickable-item" v-tooltip="'Ver Pat'" @click="goToPat(slotProps.data.pat_number)">
                        <strong>{{ slotProps.data.pat_number }}</strong>
                    </span>
                </template>
            </Column>

            <Column field="parts" header="Peças" :style="{ minWidth: '300px' }">
                <template #body="slotProps">
                    <div v-if="slotProps.data.parts && slotProps.data.parts.length > 0">
                        <div
                            v-for="part in slotProps.data.parts"
                            :key="part.id"
                            class="part-item p-mb-2"
                        >
                            <div class="p-d-flex p-ai-center p-mb-1">
                                <Badge
                                    :value="part.quantity"
                                    severity="primary"
                                    class="p-mr-2"
                                />
                                <strong>{{ part.ref?.trim() }}</strong>
                            </div>
                            <div class="p-text-secondary" style="font-size: 0.9rem;">
                                {{ part.design }}
                            </div>
                            <div v-if="part.destination_warehouse_id" class="p-text-secondary" style="font-size: 0.85rem;">
                                Armazém: {{ part.destination_warehouse_id }} - {{ part.destination_warehouse_name }}
                            </div>
                        </div>
                    </div>
                    <div v-else class="p-text-secondary">
                        <i class="pi pi-minus"></i> Sem peças
                    </div>
                </template>
            </Column>

            <Column field="pat_brand" header="Equipamento" :style="{ minWidth: '200px' }">
                <template #body="slotProps">
                    <div>
                        <strong>{{ slotProps.data.pat_brand?.trim() }}</strong>
                    </div>
                    <div>{{ slotProps.data.pat_model?.trim() }}</div>
                    <small class="p-text-secondary">SN: {{ slotProps.data.pat_serial_number }}</small>
                </template>
            </Column>

            <Column field="contact_name" header="Cliente" :style="{ minWidth: '200px' }">
                <template #body="slotProps">
                    <div>{{ slotProps.data.contact_name }}</div>
                </template>
            </Column>
        </DataTable>
      </div>
      <template #footer>
        <Button
          label="Fechar"
          icon="pi pi-times"
          class="p-button-text"
          @click="close"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>

import supportService from '@/services/support.service';

export default {
  name: "ShowAllParts",
  props: ["show", "currentDate" ],
  data() {
    return {
        list: [],
        localShow: false,
        loading: false,
    };
  },
  watch: {
    show: {
      immediate: true,
      handler(newVal) {
        this.localShow = newVal;
        if (newVal) {
          this.onDialogOpen();
        }
      }
    },
    localShow(newVal) {
      if (!newVal && this.show) {
        this.$emit("close");
      }
    }
  },
  methods: {
    onDialogOpen() {
        this.fetchParts();
    },
    fetchParts() {
        this.list = [];
        this.loading = true;

        if (!this.currentDate) {
            this.$toast.add({ severity: 'warn', summary: 'Aviso', detail: 'Data inválida para carregar as peças.', life: 3000 });
            this.loading = false;
            return;
        }

        supportService.getPartsToUse(this.currentDate)
            .then(response => {
                if (!response || response.length === 0) {
                    this.list = [];
                }

                this.list = response;
            })
            .catch(error => {
                console.error("Error fetching parts:", error);
                this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Não foi possível carregar as peças.', life: 3000 });
            })
            .finally(() => {
                this.loading = false;
            });
    },
    close() {
    this.localShow = false;
    },
    rowClass(data) {
        if (data.parts && data.parts.length > 0) {
            return 'task-with-parts';
        }
        return '';
    },
    goToPat(patId) {
        this.$router.push(`/pats/${patId}`);
    },
  }
};
</script>

<style scoped>
.part-item {
    padding: 8px;
    background-color: #f8f9fa;
    border-radius: 4px;
    border-left: 3px solid #2196F3;
}

.part-item:last-child {
    margin-bottom: 0 !important;
}

.summary-card {
    text-align: center;
    padding: 1rem;
    background: #f8f9fa;
    border-radius: 6px;
}

.summary-label {
    font-size: 0.9rem;
    color: #6c757d;
    margin-bottom: 0.5rem;
}

.summary-value {
    font-size: 2rem;
    font-weight: bold;
    color: #2196F3;
}

.task-with-parts {
    background-color: #f0f9ff !important;
}

::v-deep .p-datatable .p-datatable-tbody > tr > td {
    padding: 1rem;
}

</style>